import { render } from "./IconPenaltyMiss.vue?vue&type=template&id=761cfc46&ts=true"
import script from "./IconPenaltyMiss.vue?vue&type=script&lang=ts"
export * from "./IconPenaltyMiss.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__